<script>
export default {
  name: "AvailabilityStatus",
  props: {
    loanable: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasBlockingIncident() {
      return this.loanable.active_incidents?.filter((i) => i.is_blocking).length > 0;
    },
    hasIncident() {
      return this.loanable.active_incidents?.length > 0;
    },
  },
};
</script>

<template>
  <div class="status-list">
    <b-badge
      v-if="loanable.availability_status === 'no_approved_communities'"
      v-b-tooltip="$t('components.loanable.availability_status.no_approved_communities_tooltip')"
      variant="warning"
    >
      {{ $t("components.loanable.availability_status.no_approved_communities") }}
    </b-badge>
    <b-badge
      v-else-if="loanable.availability_status === 'wrong_type'"
      v-b-tooltip="
        $t('components.loanable.availability_status.wrong_type_tooltip', {
          type: $t(`loanables.fields.types.${loanable.type}`),
        })
      "
      variant="danger"
    >
      {{
        $t("components.loanable.availability_status.wrong_type", {
          type: $t(`loanables.fields.types.${loanable.type}`),
        })
      }}
    </b-badge>
    <b-badge
      v-else-if="loanable.availability_status === 'no_availabilities'"
      v-b-tooltip="$t('components.loanable.availability_status.no_availabilities_tooltip')"
      variant="warning"
    >
      {{ $t("components.loanable.availability_status.no_availabilities") }}
    </b-badge>
    <b-badge v-else-if="loanable.availability_status === 'unpublished'" variant="secondary">
      {{ $t("components.loanable.availability_status.unpublished") }}
    </b-badge>
    <b-badge v-else-if="loanable.availability_status === 'has_availabilities'" variant="success">
      {{ $t("components.loanable.availability_status.has_availabilities") }}
    </b-badge>

    <b-badge v-if="hasBlockingIncident" variant="danger"
      ><b-icon icon="exclamation-triangle" class="mr-1" />{{
        $t("components.loanable.availability_status.blocking_incident")
      }}</b-badge
    >
    <b-badge v-else-if="hasIncident" variant="warning"
      ><b-icon icon="exclamation-triangle" class="mr-1" />{{
        $t("components.loanable.availability_status.non_blocking_incident")
      }}</b-badge
    >
  </div>
</template>

<style scoped lang="scss">
.status-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}
</style>
